import { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { showAlert } from "../../../reducer/alertSlice";

const Wrap = styled.div`
    input {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        pointer-events: none;
    }

    label {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid rgba(231, 234, 243, 1);
        width: ${(16/9) * 150}px;
        height: 150px;
        border-radius: 5px;
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center;
        background-color: #fff;
        cursor: pointer;

        &.is-invalid {
            border-color: #ed4c78;
        }

        svg {
            color: rgba(113, 134, 157, 0.5);
        }

        &.fill {
            cursor: default;

            .icn-add {
                opacity: 0;
            }
        }

        .btn-remove {
            position: absolute;
            display: flex;
            align-items: center;
            justify-content: center;
            top: 5px;
            right: 5px;
            background-color: #fff;
            border: 1px solid rgba(113, 134, 157, 0.5);
            width: 15px;
            height: 15px;
            cursor: pointer;
        }
    }

`;

// max단위: MB 
export default function InputFilePreview({register, invalid, defaultValue, max=5, ...props}) { 
    const [previewImg, setPreviewImg] = useState(null);
    const inputRef = useRef();
    const dispatch = useDispatch();
    const handleInputChange = async (event) => {
        const maxSize = max * 1024 * 1024;
        const file = await event.currentTarget.files[0];
        // 추가
        if (file) {
            if (file.size > maxSize) {
                dispatch(showAlert({
                    msg: <>등록 가능한 이미지 용량을 초과하였습니다.<br/>(최대 {max}MB까지 등록 가능)</>
                }));
                event.currentTarget.value = "";
                return;
            } else {
                var reader = new FileReader();
                reader.onload = function(e) {
                    setPreviewImg(e.target.result);
                };
                reader.readAsDataURL(file);
            }
        }
        register.onChange(event);
        register.onBlur(event);
    }

    useEffect(() => {
        setPreviewImg(defaultValue);
        if (inputRef) {
            inputRef.current.addEventListener("change", (e) => {
                handleInputChange(e);
            });
        }
    },[])

    return (
    <Wrap>
        <label className={previewImg ? `${invalid ? "is-invalid" : ""} fill` : invalid && "is-invalid"} 
        style={{backgroundImage: "url("+previewImg+")"}}
        onClick={(e) => {
            if (previewImg) {
                e.preventDefault();
            }
        }}
        >
            {
                previewImg &&
                <div className="btn-remove" onClick={(e) => {
                    setPreviewImg(null);
                    inputRef.current.value = "";
                    inputRef.current.dispatchEvent(new Event("change"));
                }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                    </svg>
                </div>
            }
            {
                !previewImg &&
                <svg className="icn-add" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"/>
                </svg>
            }
            <Form.Control {...register} type="file" 
                isInvalid={invalid} {...props} 
                ref={e => {register.ref(e); inputRef.current = e;} }></Form.Control>
        </label>
        <Form.Control.Feedback type="invalid">{invalid && invalid['message']}</Form.Control.Feedback>
    </Wrap>
    )
}